export default __webpack_public_path__ + "static/bean-climbing-257d79c0fe150f19a3e79ca5f186605d.svg";